import React, { Dispatch, SetStateAction } from 'react';

import { UserDetail } from '@atom/types/user';

export enum View {
  INFO,
  BUDGETS,
  PERMISSIONS,
  CERTIFICATIONS,
  WORK,
  SETTINGS,
  ROLES,
}

interface Context {
  user: UserDetail;
  activeView: View;
  setActiveView: Dispatch<SetStateAction<View>>;
  loading: boolean;
  refetch: () => Promise<any>;
}

export const initialState: Context = {
  activeView: View.INFO,
  setActiveView: () => {},
  // @ts-ignore
  user: {},
  loading: false,
  refetch: () => Promise.resolve({}),
};

const UserContext = React.createContext<Context>(initialState);

export default UserContext;
